const commonStyles = [
    'bg-yellow-ffcc00', 'text-black', 'text-10px', 'transform', 'transition-opacity', 'duration-200', 'delay-3000',
    'absolute', 'top-0', 'left-0', 'z-1',
    'flex-xyc', 'text-center', 'primary-bg', 'radius-4px', 'p-10', 'fs-10px', 'black', 'text-nowrap', 'i-1',
].join(' ');

export const defaultNotificationsConfig = {
    types: {
        headerCart: {
            $target: document.getElementById('vHeader-notificationsBox'),
            template:
                `<a href="${GLOBAL_CONFIG.cart_domain}" class="${commonStyles} p-10 min-w-160 text-center" style="z-index: 1100;">
                    {{content}}
                </a>`,
            position: 'left'
        },
        header: {
            $target: document.getElementById('vHeader-notificationsBox'),
            template:
                `<span class="${commonStyles} p-10 min-w-160 text-center" style="z-index: 1100;">
                    {{content}}
                </span>`,
            position: 'left'
        },
        storageItem: {
            template:
                `<span class="${commonStyles} p-10 whitespace-nowrap">
                    {{content}}
                </span>`,
            position: 'left'
        },
        cartDefaultButton: {
            template:
                `<span class="${commonStyles} px-10 w-full h-full whitespace-nowrap">
                    {{content}}
                </span>`
        },
        cartRoundedSuccessButton: {
            template:
                `<span class="${commonStyles} p-10 w-full h-full flex-xyc rounded-full text-center">
                    <span class="icon icube-icon-check"></span>
                </span>`
        },
        cartRoundedErrorButton: {
            template:
                `<span class="${commonStyles} p-10 w-full h-full flex-xyc rounded-full text-center">
                    <span class="icon icube-icon-times"></span>
                </span>`
        }
    }
}